<app-top-menu-two *ngIf="showTopMenu"></app-top-menu-two>
<div style="max-width: 800px; margin: auto; overflow: hidden;" *ngIf="!this.showLoading">

  <!--Nav Top-->
  <app-nav-top [title]="pageTitle" (back)="goback()"></app-nav-top>
  
  <div class="main-address" style="height: 100%">
    <div class="text-initial" *ngIf="!sucessLocalization">
      Qual é seu endereço?
    </div>
    <div class="text-initial" *ngIf="sucessLocalization">
      Selecione sua localização:
    </div>
    <div class="address">
      <div class="address-title">
      </div>

      <!--Cep-->
      <div id="conteudo" class="address-content" *ngIf="!requestApi && !sucessLocalization">
        <div class="address-header">
          <span style="font-size: 15px;">Digite seu CEP:</span>
          <!-- <span class="not-cep" (click)="this.requestApi = true">Não sei meu CEP!</span> -->
        </div>
        <div class="d-flex flex-column box-input-address">
          <form style="display: flex;flex-direction: column; gap: 10px;">
            <input [ngModel]="cep" name="address" class="input-address" type="text" placeholder="12345678" maxlength="8" (ngModelChange)="filterInput($event)" (input)="getLocalizationCEP($event)">
          </form>
          <div class="result-searsh" *ngIf="this.cep.length == 8 && showAddress" (click)="openLocalizationCEP()">
            <div class="result-icon">
              <i class="fa-solid fa-location-dot"></i>
            </div>
            <div class="result-content">
              <div>{{ this.addressCep.street }}</div>
              <div>{{ this.addressCep.neighborhood }}, {{ this.addressCep.city }} - {{ this.addressCep.state }}, {{ this.addressCep.postalCode }}</div>
            </div>
          </div>
        </div>
        <div class="button-my-localization">
          <button (click)="this.requestApi = true">Não sei meu CEP</button>
        </div>
      </div>

      <div *ngIf="this.sucessLocalization">
        <ng-container *ngFor="let address of this.listLocalization">
          <div class="result-searsh-not" (click)="openLocalization(address)">
            <div class="result-icon">
              <i class="fa-solid fa-location-dot"></i>
            </div>
            <div class="result-content">
              <div>{{ address.street }}</div>
              <div>{{ address.neighborhood }}, {{ address.city }} - {{ address.state }}, {{ address.postalCode }}</div>
            </div>
          </div>
        </ng-container>

      </div>

      <!--Endereço completo-->
        <div *ngIf="this.requestApi && !this.showLoading">
          <div class="address-title">
          </div>
          <div id="conteudo" class="address-content">
            <form class="d-flex box-input-address flex-column" style="gap: 5px;" (ngSubmit)="openModalAddress()">
              <!--Rua-->
              <div class="div-box">
                <span class="span-inputs">Rua:*</span>
                <input class="inputs" name="street" [(ngModel)]="address.street" required="required" formatation>
              </div>

              <!--Número-->
              <div class="div-box" [ngStyle]="{ opacity: notNumber ? '0.5' : '' }">
                <span class="span-inputs">Número:*</span>
                <input type="text" class="inputs" name="number" [(ngModel)]="address.number" required="required" [disabled]="notNumber" formatation>
              </div>

              <!--CheckBox Sem número-->
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" (click)="changeCheckBox($event)" [(ngModel)]="notNumber" [ngModelOptions]="{ standalone: true }">
                <label class="form-check-label" style="height: 29px; display: flex; align-items: center;" for="inlineCheckbox1">Sem número</label>
              </div>

              <!--Bairro-->
              <div class="div-box" *ngIf="company.configs.deliveryType == 0">
                <span class="span-inputs">Bairro:*</span>
                <input class="inputs" type="text" name="neighborhood" [(ngModel)]="address.neighborhood" required="required" formatation>
              </div>

              <!--Bairro-->
              <div class="div-box" *ngIf="company.configs.deliveryType == 1">
                <span class="span-inputs">Bairro:*</span>

                <div class="div_options_select" id="generic-select" tabindex="-1" (blur)="openOptions = false" #modalOptions>
                  <div class="box-input-neighbordhood">
                    <input 
                      class="inputs" 
                      [ngClass]="{'invalid': this.invalidNeighborhood}"
                      type="text"
                      name="searchNeighborhood"
                      placeholder="Digite ou selecione um bairro"
                      [(ngModel)]="searchNeighborhood"
                      (focus)="openOptions = true"
                      (input)="filterNeighborhoods()"
                      autocomplete="off"
                      style="width: 100%;"
                    />
                    <div class="icon-chevron-down" [ngClass]="{'rotate': openOptions}" (click)="openOptions = !openOptions"></div>
                  </div>

                  <span *ngIf="this.invalidNeighborhood" class="info-error">Não encontramos esse bairro. Verifique o nome ou selecione na lista.</span>

                  <div class="options_select" [ngClass]="{'invalid-select': this.invalidNeighborhood}" style="z-index: 2;" *ngIf="openOptions">
                    <ng-container *ngFor="let bairro of filteredNeighborhoods">
                      <span class="option_selected" [ngClass]="{'select': this.searchNeighborhood.toLowerCase() == bairro.neighborhood.toLowerCase()}" (click)="selectNeighborhood(bairro.neighborhood)">
                        {{ bairro.neighborhood }}
                      </span>
                    </ng-container>
                    <span style="text-align: center; color: gray;" *ngIf="this.filteredNeighborhoods.length == 0 && this.searchNeighborhood != ''" class="option_selected">Nenhum bairro encontrado.</span>
                  </div>
                </div>
                <span class="info-tip">

                </span>

                <div class="massage-warning-new">
                  <div class="warning-icon">
                    <i class="fa-regular fa-bell bell-animation"></i>
                  </div>
                  <div class="box-text">
                    <span class="text-warningg">
                      A taxa de entrega é configurada por bairro.<br>
                      Se não encontrar o seu bairro, consulte o restaurante para verificar a disponibilidade.
                    </span>
                  </div>
                </div>
              </div>    

              <!--Cidade-->
              <div class="div-box">
                <span class="span-inputs">Cidade:*</span>

                <div class="div_options_select" id="city-select" tabindex="-1">
                  <!--Input-->
                  <div class="box-input-neighbordhood">
                    <input
                      class="inputs"
                      [ngClass]="{'invalid': this.invalidCity}"
                      type="text"
                      name="searchCity"
                      placeholder="Digite ou selecione a cidade"
                      [(ngModel)]="searchCity"
                      (focus)="openOptionsCity = true"
                      (input)="filterCities()"
                      autocomplete="off"
                      style="width: 100%;"
                    />
                    <div class="icon-chevron-down" [ngClass]="{'rotate': openOptionsCity}" (click)="openOptionsCity = !openOptionsCity"></div>
                  </div>

                  <!--Invalid-->
                  <span *ngIf="this.invalidCity" class="info-error">Cidade não encontrada. Verifique a grafia ou escolha na lista.</span>

                  <!--Box Select-->
                  <div class="options_select" style="z-index: 2;" [ngClass]="{'invalid-select': this.invalidCity}" *ngIf="openOptionsCity">
                    <!--Cidades-->
                    <ng-container *ngFor="let city of filteredCities">
                      <span class="option_selected" 
                        [ngClass]="{'select': this.searchCity == city}" 
                        (click)="selectCity(city)">
                        {{ city }}
                      </span>
                    </ng-container>
                    
                    <!--Nenhuma Cidade-->
                    <span 
                      style="text-align: center; color: gray;" 
                      *ngIf="this.filteredCities.length == 0 && this.searchCity != ''" 
                      class="option_selected">
                      Nenhuma cidade encontrada.
                    </span>
                  </div>
                </div>
              </div>

              <!--Estado-->
              <div class="div-box">
                <span class="span-inputs">Estado:*</span>

                <div class="div_options_select" id="state-select" tabindex="-1">
                  
                  <!--Input-->
                  <div class="box-input-neighbordhood">
                    <input
                      class="inputs"
                      [ngClass]="{'invalid': this.invalidState}"
                      type="text"
                      name="searchState"
                      placeholder="Digite ou selecione o estado"
                      [(ngModel)]="searchState"
                      (focus)="openOptionsState = true"
                      (input)="filterStates()"
                      maxlength="2" 
                      autocomplete="off"
                      style="width: 100%;"
                    />
                    <div class="icon-chevron-down" [ngClass]="{'rotate': openOptionsState}" (click)="openOptionsState = !openOptionsState"></div>
                  </div>

                  <!--Invalid-->
                  <span *ngIf="this.invalidState" class="info-error">Digite um estado válido (ex.: SP, RJ) ou selecione na lista.</span>

                  <!--Box Select-->
                  <div class="options_select" [ngClass]="{'invalid-select': this.invalidState}" *ngIf="openOptionsState">
                    <!--States-->
                    <ng-container *ngFor="let state of filteredStates">
                      <span class="option_selected" 
                        [ngClass]="{'select': this.searchState.toUpperCase() == state}" 
                        (click)="selectState(state)">
                        {{ state }}
                      </span>
                    </ng-container>
                    
                    <!--Nenhum Estado-->
                    <span style="text-align: center; color: gray;" *ngIf="this.filteredStates.length == 0 && this.searchState != ''" class="option_selected">
                      Nenhum estado encontrado.
                    </span>
                  </div>
                </div>
              </div>

              <!--Complemento-->
              <div class="div-box">
                <span class="span-inputs">Complemento:</span>
                <input class="inputs" type="text" name="complement" maxlength="199" [(ngModel)]="address.complement" formatation>
              </div>

              <!--Ponto de referencia-->
              <div class="div-box">
                <span class="span-inputs">Ponto de referência:</span>
                <input class="inputs" type="text" name="point" maxlength="199" [(ngModel)]="address.reference" formatation>
              </div>

              <div class="div-fixed" *ngIf="requestApi">
                <button type="submit" [ngClass]="{'disabled-positive' : !this.validForm()}">Salvar</button>
              </div>
            </form>
          </div>
        </div>

    </div>
  </div>

  <!--Button localization-->
  <div class="box-button-localization" *ngIf="!this.sucessLocalization && !this.requestApi">
    <div class="button-localization" (click)="getLocalization()">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-locate-fixed-icon lucide-locate-fixed"><line x1="2" x2="5" y1="12" y2="12"/><line x1="19" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="5"/><line x1="12" x2="12" y1="19" y2="22"/><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3"/></svg>
      </div>
      <span>Usar minha localização</span>
    </div>
  </div>



  <!--Modal Titulo do Endereço-->
  <div class="modal" [ngClass]="{'show': openModalAskTitle}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5 tittle-modal" id="staticBackdropLabel" style="font-size: 19px !important;">Endereço</h1>
        </div>
        <div class="modal-body" style="padding: 0;">
          <form (ngSubmit)="submitAddress()" style="text-align: center; width: 100%;">
            <div class="text-area">
              <span style="font-weight: 100;">Adicione um titulo ao seu endereço</span>
              <div class="box-address">
                <div class="box-address__div" (click)="selectIdentifier('Casa')">
                  <span><i class="fa-solid fa-house" style="margin-right: 7px;"></i>Casa</span>
                  <!-- <checkbox [groupName]="'addressIdentifier'" [isChecked]="address.identifier === selectedAddressIdenfier"></checkbox> -->
                  <checkbox-radius (checkboxChange)="onCheckboxChange($event)" [checkboxData]="this.optionHome"></checkbox-radius>
                </div>
                <div class="box-address__div" (click)="selectIdentifier('Trabalho')">
                  <span><i class="fa-solid fa-briefcase" style="margin-right: 7px;"></i>Trabalho</span>
                  <!-- <checkbox [groupName]="'addressIdentifier'" [isChecked]="address.identifier === selectedAddressIdenfier"></checkbox> -->
                  <checkbox-radius (checkboxChange)="onCheckboxChange($event)" [checkboxData]="this.optionWork"></checkbox-radius>
                </div>
                <div class="box-address__div" (click)="selectIdentifier('Escola')">
                  <span><i class="fa-solid fa-school" style="margin-right: 7px;"></i>Escola</span>
                  <!-- <checkbox [groupName]="'addressIdentifier'" [isChecked]="address.identifier === selectedAddressIdenfier"></checkbox> -->
                  <checkbox-radius (checkboxChange)="onCheckboxChange($event)" [checkboxData]="this.optionSchool"></checkbox-radius>
                </div>
                <div class="button-modal-person" (click)="this.showInput = !this.showInput">
                  <span>Personalizar</span>
                </div>
              </div>
              <input placeholder="Ex: Casa, Trabalho, Escola" name="identifier" *ngIf="this.showInput" [(ngModel)]="address.identifier" formatation>
            </div>
            <div class="modal-footer justify-content-center">
              <button type="button" class="btn modal-btn-negative" (click)="openModalAskTitle = false; this.enableScroll()">Cancelar</button>
              <button type="submit" class="btn modal-btn-positive" [ngClass]="{'disabled-positive' : address.identifier == '' && address.identifier.replace(' ', '').length == 0}">Confirmar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>

<app-card-loading [openCard]="showLoading" [labelPerson]="'Aguarde...'"></app-card-loading>